import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {IAlternativeSecurity, IModelSecurityEquivalent} from "@irb/irb-editors/irb-editors.model";
import {AppService} from "@irb/app.service";

@Component({ standalone: false,
    selector: 'irb-security-equivalents-alternatives',
    templateUrl: './security-equivalents-alternatives.component.html',
    styleUrls: ['./security-equivalents-alternatives.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class SecurityEquivalentsAlternativesComponent {
    selectedAltSecurity: IAlternativeSecurity;
    selectedInverseAccountType: string;
    isCashEqvEnabled: boolean;
    isUiTest = false;
    constructor(private as: AppService) {
        this.isCashEqvEnabled = this.as.getItem("IRB_APP_CONFIG")?.featureFlags?.isCashEqvEnabled || false;
    }

    @Input()
    securityEquivalentsAlternativesData: { multipleSecurity: boolean, isModelSecurity: boolean, securityData: any[] };

    @Output()
    securityEquivalentsChanged: EventEmitter<Array<IModelSecurityEquivalent>> = new EventEmitter<Array<IModelSecurityEquivalent>>();

    @Output()
    securityEquivalentsAlternativeChanged: EventEmitter<{ alternativeSecurity: IAlternativeSecurity, inverseAccountType: string }>
        = new EventEmitter<{ alternativeSecurity: IAlternativeSecurity, inverseAccountType: string }>();

    onSecurityEquivalentsChanged(equivalents: Array<IModelSecurityEquivalent>) {
        this.securityEquivalentsChanged.emit(equivalents);
    }

    onSecurityEquivalentsAlternativeChanged(event: { alternativeSecurity: IAlternativeSecurity, inverseAccountType: string }) {
        this.selectedAltSecurity = event.alternativeSecurity;
        this.selectedInverseAccountType = event.inverseAccountType;
        this.securityEquivalentsAlternativeChanged.emit(event);
    }
    isValid() {
        let isValid = true;
        if (this.selectedAltSecurity && (this.selectedAltSecurity.securityId !== 0 && !this.selectedInverseAccountType)) {
            isValid = false;
        }
        return isValid;
    }
}
